import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  OrgExpenseReportMatchParams,
  orgExpenseReportRouteProps,
  OrgExpenseReportsHistoricalReportsMatchParams,
  orgExpenseReportsHistoricalReportsRouteProps,
  SetOrgExpenseReportCycleMatchParams,
  setOrgExpenseReportCycleRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCalculatedBackgroundLocation,
  selectLocationFromState
} from 'src/redux/selectors/router.selectors'

export const selectExpenseReportsHistoricalReportsCycleIdFromRoute =
  createSelector([selectLocationFromState], (location) => {
    const mtch = matchPath<OrgExpenseReportsHistoricalReportsMatchParams>(
      location.pathname,
      orgExpenseReportsHistoricalReportsRouteProps,
    ) as match<OrgExpenseReportsHistoricalReportsMatchParams>
    return mtch?.params?.id
  })

export const selectExpenseReportIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<OrgExpenseReportMatchParams>(
      backgroundLocation.pathname,
      orgExpenseReportRouteProps,
    ) as match<OrgExpenseReportMatchParams>
    return mtch?.params?.reportId
  },
)

export const selectExpenseReportIdAndCycleIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<OrgExpenseReportMatchParams>(
      backgroundLocation.pathname,
      orgExpenseReportRouteProps,
    ) as match<OrgExpenseReportMatchParams>
    return [mtch?.params?.reportId, mtch?.params?.cycleId]
  },
)

export const selectExpenseReportCycleIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<SetOrgExpenseReportCycleMatchParams>(
      location.pathname,
      setOrgExpenseReportCycleRouteProps,
    ) as match<SetOrgExpenseReportCycleMatchParams>
    return mtch?.params?.id
  },
)

export const selectDateUpdateRequiresConfirmation = (
  state: RootState,
): boolean => state.data.organizations.reports.dateUpdateRequiresConfirmation
